import apiFetch from '../apiFetch'

export default function (campaignId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/campaign/${campaignId}/Validate`, method: 'PUT', body: null, token: token, lastAccessDate: lastAccessDate })
}
